module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "ag.b74feb72.png" + "?" + Date.now();